if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        this.loadDeferredImages();
        super.show(opener);
        this.showActiveMedia();
      }

      // Modal images are rendered without srcset/src (see product-media.liquid) so
      // they are not downloaded until the modal is first opened. They keep
      // loading="lazy", so images further along still load as they are reached.
      loadDeferredImages() {
        this.querySelectorAll('img[data-srcset], img[data-src]').forEach((image) => {
          if (image.dataset.srcset) image.srcset = image.dataset.srcset;
          if (image.dataset.src) image.src = image.dataset.src;
          image.removeAttribute('data-srcset');
          image.removeAttribute('data-src');
        });
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
